/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Version description of a PatientDocument
 * @export
 * @interface PatientDocumentVersion
 */
export interface PatientDocumentVersion {
    /**
     * 
     * @type {number}
     * @memberof PatientDocumentVersion
     */
    patientDocumentId: number;
    /**
     * 
     * @type {number}
     * @memberof PatientDocumentVersion
     */
    version: number;
}

/**
 * Check if a given object implements the PatientDocumentVersion interface.
 */
export function instanceOfPatientDocumentVersion(value: object): value is PatientDocumentVersion {
    if (!('patientDocumentId' in value) || value['patientDocumentId'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function PatientDocumentVersionFromJSON(json: any): PatientDocumentVersion {
    return PatientDocumentVersionFromJSONTyped(json, false);
}

export function PatientDocumentVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientDocumentVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'patientDocumentId': json['patientDocumentId'],
        'version': json['version'],
    };
}

export function PatientDocumentVersionToJSON(json: any): PatientDocumentVersion {
    return PatientDocumentVersionToJSONTyped(json, false);
}

export function PatientDocumentVersionToJSONTyped(value?: PatientDocumentVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientDocumentId': value['patientDocumentId'],
        'version': value['version'],
    };
}

